import {
  BillLineRef,
  hasBillField,
} from '@/features/dashboard/bookingChanges/types/BookingBill.ts';
import { ClientBillField } from '@/features/dashboard/bookingChanges/types/dto/ClientBillField.ts';

/** Pola składające się na `AddressDto` — trzy pola kontraktu, jeden wiersz rachunku. */
export const ADDRESS_BILL_FIELDS = [
  ClientBillField.STREET,
  ClientBillField.POSTAL_CODE,
  ClientBillField.CITY,
];

/**
 * Czy wiersz dotyczy adresu. Wystarczy jedno z trzech pól: `ClientDataChangeRequest`
 * niesie adres jednym obiektem, więc pozycja paczki i tak dotyczy całej trójki.
 */
export const isAddressLine = (ref: BillLineRef | null): boolean =>
  ADDRESS_BILL_FIELDS.some((field) => hasBillField(ref, field));
